import { mockComponent } from 'bloko/common/setupMockComponents';

const { TextSize, TextImportance } = jest.requireActual('bloko/blocks/text/index.js');
export { TextSize, TextImportance };

export default mockComponent('Text', null, {
    withChildren: true,
});
